import { render, staticRenderFns } from "./NucleiSettingsDialog.vue?vue&type=template&id=0c4b1678&scoped=true"
import script from "./NucleiSettingsDialog.vue?vue&type=script&lang=js"
export * from "./NucleiSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b1678",
  null
  
)

export default component.exports